import Quill, { Parchment } from "quill";

////////////////////////////////////////////////////////////////////////////////

const BlockEmbed = Quill.import("blots/block/embed") as typeof Parchment.EmbedBlot;

function sanitize(url: string, protocols: string[]) {
    const anchor = document.createElement('a');
    anchor.href = url;
    const protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
    return protocols.indexOf(protocol) > -1;
}

const ATTRIBUTES = [
    'alt',
    'height',
    'width',
    'class',
];

export default class ImageUrlBlot extends BlockEmbed {

    static blotName = 'image';
    static tagName = 'IMG';
    static MaxWidthOrHeight = 256;

    static create(value: any) {

        const node: any = super.create(value);
        var valueUrl: any = null;
        var h: any = null;
        var w: any = null;

        function fillNodeAttruibutes() {
            // Define dimensões
            node.setAttribute('src', valueUrl);
            node.setAttribute('height', h);
            node.setAttribute('width', w);
            node.style = null;
        }

        if (typeof value == "string") {
            valueUrl = value;
        }
        else if (value.hasOwnProperty("src") && value.src != null) {
            valueUrl = value.src;
            if (value.height != null && value.heigth != "null")
                h = value.height;
            if (value.width != null && value.width != "null")
                w = value.width;
        }
        else
            return node;

        // Para que os textos sejam exibidos corretamente nos CARDS, é necessário
        // que as imagens tenham ALTURA e COMPRIMENTO estabelecidos.
        if (h == null
            || w == null
            || parseInt(w) > ImageUrlBlot.MaxWidthOrHeight
            || parseInt(h) > ImageUrlBlot.MaxWidthOrHeight) {

            if (valueUrl.indexOf("file:///") > -1) {
                alert("Desculpe, mas não é possível importar uma imagem utilizando um arquivo local.");
                return null;
            }

            valueUrl = this.sanitize(valueUrl);

            // Dimensões máximas
            var img = new Image();
            img.onload = () => {
                // Dimensões máximas
                let p = 1;
                if (img.width > ImageUrlBlot.MaxWidthOrHeight || img.height > ImageUrlBlot.MaxWidthOrHeight)
                    p = (ImageUrlBlot.MaxWidthOrHeight / (img.width > img.height ? img.width : img.height));

                w = Math.trunc(img.width * p);
                h = Math.trunc(img.height * p);

                fillNodeAttruibutes();
            };
            img.src = valueUrl;
            return node;
        }

        fillNodeAttruibutes();
        return node;
    }

    static formats(domNode: any) {
        return ATTRIBUTES.reduce(function (formats: any, attribute) {
            if (domNode.hasAttribute(attribute)) {
                formats[attribute] = domNode.getAttribute(attribute);
            }
            return formats;
        }, {});
    }

    static value(node: any) {
        return {
            class: node.getAttribute('class'),
            alt: node.getAttribute('alt'),
            src: node.getAttribute('src'),
            width: node.getAttribute('width'),
            height: node.getAttribute('height'),
        };
    }

    static match(url: string) {
        return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
    }

    static register() {
        if (/Firefox/i.test(navigator.userAgent)) {
            setTimeout(() => {
                // Disable image resizing in Firefox
                document.execCommand('enableObjectResizing', false, 'false');
            }, 1);
        }
    }

    static sanitize(url: string) {
        return sanitize(url, ['http', 'https', 'data']) ? url : '//:0';
    }


    format(name: any, value: any) {
        var dom = this.domNode as any;
        if (name === 'height' || name === 'width') {
            if (value) {
                dom.setAttribute(name, value);
            } else {
                dom.removeAttribute(name, value);
            }
        } else {
            super.format(name, value);
        }
    }
}

//Quill.register(ImageUrlBlot, true);
